import React, { Component } from 'react'
import injectStyles from 'react-jss'

const styles = {
  container: {
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    top: 0,
    left: 0,
  },
  modal: {
    backgroundColor: '#333333',
    opacity: 0.8,
    width: '100vw',
    height: '100vh',
    position: 'fixed',
  },
  page: {
    textAlign: 'center',
    height: '100vh',
    minHeight: 440,
    width: '100vw',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    position: 'fixed',
  },
  boxOuter: {
    width: '100%',
    position: 'relative',
  },
}

const Dialog = ({ classes, children, onSave, onCancel, disabled }) =>
  <div className={classes.container}>
    <div className={classes.modal} />
    <div className={classes.page}>
      <div className={classes.boxOuter}>
        <Box>
          {children}
        </Box>
      </div>
    </div>
  </div>

export default injectStyles(styles)(Dialog)

const Box = injectStyles({
  box: {
    position: 'relative',
    width: 645,
    height: 440,
    borderRadius: 4,
    border: '1px solid #d9dbdf',
    boxSizing: 'border-box',
    paddingLeft: 142,
    paddingRight: 142,
    paddingTop: 86,
    margin: '0 auto',
    backgroundColor: 'white',
    '@global': {
      'h3': {
        fontWeight: 'bold',
        margin: 0,
      },
    },
  },
})(({ classes, children }) => <div className={classes.box}>
  {children}
</div>)




// WEBPACK FOOTER //
// ./src/modules/Dialog/Dialog.js